import { render } from "./Illustration_Forget.vue?vue&type=template&id=271f99a8"
import script from "./Illustration_Forget.vue?vue&type=script&lang=js"
export * from "./Illustration_Forget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__